import React from "react";
import PropTypes from 'prop-types';
import ListPoint from "./ListPoint";

export const COLOR_WHITE = 'white';

export default class ListPoints extends React.PureComponent {
    renderListPoints = () => {
        let { points, color } = this.props;

        return points.map((point, index) => {
            return <ListPoint color={color} text={point} key={index}/>
        })
    };

    render() {

        return (
            <div className={'list-point'}>
                <div className={'list-wrapper'}>
                    {this.renderListPoints()}
                </div>
            </div>
        );
    }
}

ListPoints.propTypes = {
    color: PropTypes.string,
    points: PropTypes.arrayOf(PropTypes.string),
};
